import * as React from "react";
import { withStyles } from "src/decorators";

type IBoxProps = React.HTMLProps<HTMLElement> & {
  as?: string;
};

export const Box = withStyles(({ as = "div", ...other }: IBoxProps) => {
  const Component: any = as;
  return <Component {...other} />;
});
